import React from 'react';
import PropTypes from 'prop-types';

const TYPES = [
  { type: 'basic', style: 'chk-style' },
  { type: 'button', style: 'type-btn' },
  { type: 'radio', style: '' },
];

const SatCheckBox = props => {
  const {
    value = [],
    options,
    type = 'basic',
    checkAll,
    checkOne,
    disabled,
    customStyleClass,
    onChange,
    onValidNotiModal = undefined,
  } = props;

  const handleCheckBox = selectValue => {
    if (!checkOne) {
      if (options.length > 1) {
        if (value.includes(selectValue)) {
          onChange(
            options.filter(option =>
              value.filter(v => v !== selectValue).includes(option.value),
            ),
          );
        } else {
          onChange(
            options.filter(option =>
              value.concat(selectValue).includes(option.value),
            ),
          );
        }
      } else if (options.length === 1) {
        onChange(selectValue);
      }
    } else {
      if (value.includes(selectValue)) {
        onChange([]);
      } else {
        onChange(options.filter(option => option.value === selectValue));
      }
    }
  };

  const handleCheckBoxAll = () => {
    onChange(
      value.length === options.filter(option => !option.disabled).length
        ? []
        : options.filter(option => !option.disabled),
    );
  };

  const getCheckBoxStyle = type => {
    const findStyle = TYPES.find(t => t.type === type);
    let customStyle = '';

    if (customStyleClass) {
      customStyle = customStyleClass + ' ';
    }

    if (findStyle) {
      return (customStyle += findStyle.style);
    } else {
      return (customStyle += TYPES[0].style);
    }
  };

  return (
    <>
      {checkAll && !checkOne && (
        <div
          className={`check-wrap ${getCheckBoxStyle(type)}`}
          onClick={() => {
            if (!disabled) {
              handleCheckBoxAll();
            } else {
              if (onValidNotiModal && typeof onValidNotiModal === 'function') {
                onValidNotiModal(value);
              }
            }
          }}
        >
          <input
            type="checkBox"
            disabled={disabled}
            checked={value.length === options.length}
            onChange={() => console.log('')}
          />
          <label>전체</label>
        </div>
      )}

      {options.length === 1 &&
        options.map(option => (
          <div
            className={`check-wrap ${getCheckBoxStyle(type)}`}
            key={option}
            onClick={() => {
              if (!disabled && !option.isFixed) {
                handleCheckBox(!value[0]);
              } else {
                if (
                  onValidNotiModal &&
                  typeof onValidNotiModal === 'function'
                ) {
                  onValidNotiModal(option.value);
                }
              }
            }}
          >
            <input
              type="checkBox"
              value={option.value}
              checked={value[0]}
              disabled={disabled}
              onChange={() => console.log('')}
            />
            <label className={`${option.isFixed ? 'lock' : ''}`}>
              {typeof option.label === 'string' && option.label}
              {typeof option.label === 'function' && option.label()}
            </label>
          </div>
        ))}

      {options.length > 1 &&
        options.map(option => (
          <div
            className={`check-wrap ${getCheckBoxStyle(type)}`}
            key={option.value}
            onClick={() => {
              if (!disabled) {
                if (!option.disabled && !option.isFixed) {
                  handleCheckBox(option.value);
                } else {
                  if (
                    onValidNotiModal &&
                    typeof onValidNotiModal === 'function'
                  ) {
                    onValidNotiModal();
                  }
                }
              } else {
                if (
                  onValidNotiModal &&
                  typeof onValidNotiModal === 'function'
                ) {
                  onValidNotiModal();
                }
              }
            }}
          >
            <input
              type="checkBox"
              value={option.value}
              checked={value.includes(option.value)}
              disabled={disabled ? true : option.disabled || false}
              onChange={() => console.log('')}
            />
            <label className={`${option.isFixed ? 'lock' : ''}`}>
              {typeof option.label === 'string' && option.label}
              {typeof option.label === 'function' && option.label()}
            </label>
          </div>
        ))}
    </>
  );
};

SatCheckBox.propTypes = {
  /**
   * 입력 값
   */
  value: PropTypes.array,
  /**
   * options
   */
  options: PropTypes.array,
  /**
   * checkbox 타입
   */
  type: PropTypes.oneOf(['basic', 'button', 'radio']),
  /**
   * 전체(그룹) all 체크박스 사용유무
   */
  checkAll: PropTypes.bool,
  /**
   * 단일선택 체크박스 사용유무
   */
  checkOne: PropTypes.bool,
  /**
   * 체크박스 disabled(option에 해당사항은 아님)
   */
  disabled: PropTypes.bool,
  /**
   * 커스텀 스타일 class
   */
  customStyleClass: PropTypes.string,
  /**
   * 사용자 checkbox 선택 값 callback event
   */
  onChange: PropTypes.func,
  /**
   * disabled 시 알림을 위한 callback event
   */
  onValidNotiModal: PropTypes.func,
};

SatCheckBox.defaultProps = {
  value: [],
  options: [],
  type: 'basic',
  checkAll: false,
  checkOne: false,
  disabled: false,
  customStyleClass: '',
  onChange: undefined,
  onValidNotiModal: undefined,
};

export default SatCheckBox;
